import { cn } from '@hetivo/hetivo-lib-web-utils';
import * as React from 'react';

// ─── Props ────────────────────────────────────────────────────────────────────

export interface BreadcrumbWrapperProps {
  children: React.ReactNode;
  interactive?: boolean;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function BreadcrumbWrapper({ children, interactive = true }: BreadcrumbWrapperProps): React.JSX.Element {
  return (
    <div
      className={cn(
        'group/breadcrumb -mx-1 w-fit rounded-md px-1 py-0.5 transition-colors',
        interactive ? 'cursor-pointer hover:bg-muted' : 'cursor-default',
      )}
    >
      {children}
    </div>
  );
}
